export default "__VITE_ASSET__CYBwmluu__"